module.exports = __webpack_public_path__ + "static/project-21b-151bfdf3be8f85660ace6c0adcb3a400.png";